import { inject, watch } from "vue";
//#region src/components/ScalarMarkdown/useMarkdownRenderHooks.ts
/** Per-reference hooks; separate API Reference instances do not share enhancements. */
var MARKDOWN_RENDER_HOOKS = Symbol("scalar-markdown-render-hooks");
/** Run enhancements after rendering and dispose them when Markdown changes or unmounts. */
var useMarkdownRenderHooks = (element, source, html) => {
	const hooks = inject(MARKDOWN_RENDER_HOOKS, []);
	watch([
		element,
		source,
		html
	], ([container, markdown], _, onCleanup) => {
		if (!container || !hooks.length) return;
		const controller = new AbortController();
		const cleanups = [];
		onCleanup(() => {
			controller.abort();
			for (const cleanup of cleanups.reverse()) try {
				cleanup();
			} catch (error) {
				console.error("Could not dispose Markdown enhancement:", error);
			}
		});
		for (const hook of hooks) Promise.resolve().then(() => {
			if (controller.signal.aborted) return;
			return hook({
				element: container,
				source: markdown,
				signal: controller.signal
			});
		}).then((cleanup) => {
			if (!cleanup) return;
			if (controller.signal.aborted) cleanup();
			else cleanups.push(cleanup);
		}).catch((error) => {
			if (!controller.signal.aborted) console.error("Could not enhance Markdown:", error);
		});
	}, {
		flush: "post",
		immediate: true
	});
};
//#endregion
export { MARKDOWN_RENDER_HOOKS, useMarkdownRenderHooks };

//# sourceMappingURL=useMarkdownRenderHooks.js.map